import z from "zod";
import { EmailNotificationType } from "__generated__/enums";
import { fleetSelectOptionSchema } from "view/fleets/utils/fleet.schema";

export const userPushSettingSchema = z.object({
	jsonUrl: z.string(),
	jsonUsername: z.string(),
	jsonPassword: z.string(),
	confirmPassword: z.string(),
	customHeaderKey: z.string(),
	customHeaderValue: z.string(),
});

export type UserPushSettingSchemaInput = z.input<typeof userPushSettingSchema>;
export type UserPushSettingSchemaOutput = z.output<typeof userPushSettingSchema>;

export const userEditSchema = z.object({
	userEmailNotificationType: z.enum(EmailNotificationType).nullable(),
	preferredCurrency: z.object({
		isoCode: z.string().nullable(),
	}).nullable(),
	fleets: z.array(fleetSelectOptionSchema).nullable(),
	allowSystemInput: z.boolean(),
	apiPassword: z.string(),
});

export type UserEditSchemaInput = z.input<typeof userEditSchema>;
export type UserEditSchemaOutput = z.output<typeof userEditSchema>;
